import axios from 'axios';

export default {
    async verifyPassword(email: string, password: string): Promise<boolean> {
        return new Promise(async (resolve) => {
            const API_KEY = process.env.REACT_APP_API_KEY;
            axios.defaults.baseURL = 'https://www.googleapis.com/identitytoolkit/v3/relyingparty';
            const parameters = `/verifyPassword?key=${API_KEY}`;
            axios
                .post(parameters, {
                    email,
                    password,
                    returnSecureToken: true
                })
                .then(() => {
                    resolve(true);
                })
                .catch(() => {
                    resolve(false);
                });
        });
    }
};
